exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "app-action-bar.fixed{position:fixed;top:51px;left:0;right:0;background:#fff;z-index:1000}.app-action-bar .change-owner-button{float:left}.app-action-bar .change-owner-button:hover{background:#3ec19d!important;color:#fff;border-color:#3ec19d}.applications .archive-success{max-width:1440px;margin:8px auto;width:96%;border:1px solid #4571cc;border-radius:5px;background:#e0e7f6;padding:14px 55px 14px 2%;position:relative;display:block;color:#4571cc}.app-action-bar .button-blue .archive-buttons,.app-action-bar .button-blue .unarchive-buttons{width:100%}@media screen and (max-width:768px){.app-action-bar .button-blue a{background-position:left 10px center!important}.app-action-bar .button-blue .unarchive-buttons .unarchive-butt{font-size:12px}.app-action-bar .button-blue .unarchive-buttons .delete-butt{position:absolute;left:145px}.app-action-bar .button-blue .unarchive-buttons .share-butt{position:absolute;left:280px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./directives/appActionBar/appActionBar.scss
// module id = 534
// module chunks = 0